(function() {
  'use strict';

  function NetworkController($scope, $translate, StatusService) {
    var ctrl = this;

    function updateTranslatedStatus() {
      if (ctrl.info && ctrl.info.mode) {
        ctrl.info.mode.translatedStatus = $translate.instant(ctrl.info.mode.status);
      }
    }

    ctrl.setModeOffline = function() {
      StatusService.setModeOffline();
    };

    ctrl.setModeOnline = function() {
      StatusService.setModeOnline();
    };

    ctrl.relogin = function() {
      StatusService.relogin();
    };

    ctrl.info = StatusService.getInfo();
    updateTranslatedStatus();
    $scope.$on('KZStatusInfoUpdated', function(_evt, info) {
      _.assignIn(ctrl.info, info);
      updateTranslatedStatus();
    });
  }

  NetworkController.$inject = [
    '$scope',
    '$translate',
    'StatusService'
  ];

  angular.module('blocks.network')
    .controller('NetworkController', NetworkController);
})();
